import { Box, Button, Circle, Image, Text } from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons"
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { startTopic } from "../../redux/api/apiCalls";
import AlertMessage from "../common/AlertMessage";
import { ReactComponent as FilesIcon } from '../../svg/file-black.svg'
import { ReactComponent as VideoFilesIcon } from '../../svg/video-file.svg'

export default function TopicDetails({ topic_id, image, title, quizzes, method, status, content_url, courseId, fileType }) {
    const [buttonText, setButtonText] = useState(null)
    const dispatch = useDispatch()
    const { id, isStarting, started, error } = useSelector(state => state.topicStartState)
    const [isOpen, setIsOpen] = useState(false)

    const onClose = () => setIsOpen(false)

    const clickHandler = () => {
        if (status === "P") {
            dispatch(startTopic(topic_id, courseId))
        }
        else {
            method(topic_id, content_url, status)
        }
    }

    useEffect(() => {
        if (started && id === topic_id) {
            method(id, content_url, status)
        }
        // eslint-disable-next-line
    }, [started])

    useEffect(() => {
        if (id === topic_id && error) {
            setIsOpen(true)
        }
        // eslint-disable-next-line
    }, [error])

    useEffect(() => {
        if (status === "I") {
            setButtonText('In Progress')
        }
        if (status === 'P') {
            setButtonText('Start')
        }
        if (status === 'C') {
            setButtonText("Completed")
        }

    }, [status])

    return (
        <Box
            d='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
            py='1rem'
            position='relative'
            px='1.5rem'
        >
            <Box d='flex' justifyContent='flex-start' alignItems='center' pointerEvents='none'>
                <Circle size='40px' mr='1.5rem' >
                    <Image
                        src={image}
                        fallbackSrc={"https://source.unsplash.com/random/800x600"}
                        width='100%'
                        height='100%'
                        objectFit='cover'
                        borderRadius='50%'
                    />
                </Circle>
                <Box
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    d='flex'
                    flexDir='column'
                    justifyContent='center'
                    alignItems='flex-start'
                    flexGrow='1'
                >
                    <Text fontWeight='700' fontSize={['8px', '12px', '16px', '16px']} color='#333333'>{title}</Text>
                    <Box d = 'flex' justifyContent = 'center' alignItems = 'center'>
                        {fileType ? <VideoFilesIcon width='16px' height='16px' /> : <FilesIcon width='14px' height='14px' />}
                        <Text ml = '1' fontWeight='400' fontSize={['8px', '11px', '13px', '13px']} color="#1B1A1AB2"> File | {quizzes} {quizzes > 1 ? 'Quizzes' : 'Quiz'}</Text>
                    </Box>
                </Box>
            </Box>
            <Button
                p={['2px 8px', '3px 9px', '6px 18px', '8px 20px']}
                bg='#3dae33'
                // opacity={['1','1','1',opacityState ? '1' : '0']}
                _hover={{ bg: "#369c2c" }}
                transition='opacity 200ms ease'
                borderRadius='10px'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontWeight='800'
                fontSize={['8px', '8px', '10px', '11px']}
                color='#FFFFFF'
                loadingText='Starting...'
                isLoading={id === topic_id && isStarting}
                textTransform='uppercase'
                onClick={clickHandler}
            >
                {buttonText === 'Completed' ? <CheckIcon /> : buttonText}
            </Button>
            <Box
                width='75%'
                height='1px'
                bg='rgba(255, 255, 255, 0.2)'
                position='absolute'
                bottom='0'
                right='5'
            ></Box>

            <AlertMessage
                isOpen={isOpen}
                onClose={onClose}
                AffirmativeButtonColor='red'
                AffirmativeButtonText='OK'
                message='Something went wrong. Please try again later!'
                text='Error!'
            />
        </Box>
    )
}